<template>
	<div class="login">
		<el-dialog  :visible.sync="LoginShow"   center width='507px' :show-close='false'  class='loginDialogClass' :lock-scroll='false'
		:close-on-press-escape='false' :close-on-click-modal='false' top='21vh'  destroy-on-close>
		<!-- 自定义头部 -->
			<template #title>
				<div  class="dialog_title">
					<div class="left">
						<el-image :src="require('@/assets/login/login_tx@2x.png')"></el-image>
					</div>
					<div class='mind'>
						登录胖哒云游
					</div>
				</div>
				<div class="closeRight">
					<div class="right_div"  @click="dialogClose">
					</div>
				</div>
			</template>
			<el-form :model="form" :rules='rules' style='margin: 0 auto;' @keyup.13.native='Login(form)'>
				<el-form-item prop='sjh'>
					<el-input v-model="form.sjh" autocomplete="off"  placeholder="请输入手机号" :maxlength='11' 
						style='width: 82%; margin: 0 9%;'>
						<el-image :src="require('@/assets/login/sjh@2x.png')" slot="prefix" style='width: 38px;height: 38px;vertical-align: middle;margin: 16px 0;'></el-image>
					</el-input>
				</el-form-item>
				<el-form-item prop='yzm'>
				<template>
					<div style="display: flex;justify-content: space-between;position: initial;">
						<el-input v-model="form.yzm" autocomplete="off"  placeholder="请输入验证码"  :maxlength='4' 
						style='width: 82%;margin: 0 9%;' >
							<el-image :src="require('@/assets/login/login_yzm@2x.png')" slot="prefix" style='width: 38px;height: 38px;vertical-align: middle;margin: 16px 0;'></el-image>
						</el-input>
						<el-button  @click='getYZM()' :disabled='!form.sjh.length>=1'  round class='yzmBtn btnHover'
						>
							{{yzmMsg}}
						</el-button>
					</div>
				</template>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="Login(form)" round 
			style='background-color:rgba(249,221,74,1);color: #000;border-color: rgba(249,221,74,1);padding: 24px 150px;width: 82%;
			margin-left: -20px;border-radius: 37px;margin-bottom: 40px;
			font-size: 17px;margin: 0 auto 40px;' 
			class='btnHover'>
				免注册登录
			</el-button>
		</div>
		</el-dialog>
	</div>
</template>

<script>
	import {Dialog,Form,FormItem,Input,Message} from 'element-ui';
	import Vue from 'vue';
	import { JSEncrypt } from 'jsencrypt'
	Vue.use(Dialog).use(Form).use(Input)
	.use(FormItem);
	export default{
		name:'Login',
		props:{
			LoginShow:Boolean,
		},
		data(){
			var validatorSjhLength = ((rule, value, callback)=>{
				if(value.length<11){
					callback(new Error('手机号必须为11位'));
				}else{
					callback();
				}
			});
			var validatorYzmLength = ((rule, value, callback)=>{
				if(value.length<4){
					callback(new Error('验证码长度为4位'));
				}else{
					callback();
				}
			});
			return{
				userInfo:{},
				yzmMsg:'获取验证码',
				yzmLoading:false,
				browserDialogShow:false,
				form:{
					sjh:'',
					yzm:''
				},
				rules:{
					sjh:[
						{validator:validatorSjhLength,trigger: 'blur'}
					],
					yzm:[
						{validator:validatorYzmLength,trigger: 'blur'}
					]
				},
				public_key: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjs9W0qLWft3ZaaD1EoO0cczcfiRo5qOpNZgy265h1Sf2/u35u3Mh/D/sNj/0mS5nvY+/PRmmhOTxrPKhUKP8l9Ym4rB78Cod0M01nv8QXRnQTeZc7F6ApmVkFOi8IjxdhiVlbjyGoVO/qWAv3QmtXMTizfoBqMI3dHFmMzfI3BIxLoUDaxRqXpcSxrJAnaG4rzmfzhqpbGJX0dliNNJg4NKvDiTMn+YTsjmHkymFDBFPTZchToLcL7k9OQSnhlfNBgR/RYmllOdQAuo039oWCQqEa6Q29erSQ06LUE71P93XWkK829p0Be/WkX+6OZSpIfOu6YoJ+RCG8Y5UcDfYywIDAQAB'
			}
		},
		mounted() {
			// let that = this;
			// Message('mounted')
		},
		methods:{
			getLoginInfo(){
				let that = this;
				if(!localStorage['login']||localStorage['login']==null)return;
				let url = 'api/v1/cloud_pc/app/user_info';
				that.$req.post(url,{},)
				
				.then(res=>{
					console.info(res);
					if(res.data.data){
						that.userInfo = res.data.data;
						let str = res.data.data.phone;
						that.userInfo.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
					}else{
						// token 过期 默认清除登录信息
						that.loginOut();
					}
					
				})
				.catch(err=>{
					console.error(err);
				})
			},
			Login(form){
				let that = this;
				// console.info(form);
				// form.sjh = '17688563232';form.yzm = '9882';
				if(form.sjh!=''&&form.yzm!=''){
					that.$utils.Burying({act:'mianzuceLogin',operating_system:'web'});
					// 登录后才进行跳转
					let url = 'api/v1/cloud_pc/app/login_phone';
					let data = {
						phone:form.sjh,
						code:form.yzm,
						channel:sessionStorage['channel']||'official', // 20241129官网注册的用户默认注册为安卓官网渠道
					};
					
					that.$req.post(url,data)
					.then(res=>{
						// console.info(res)
						if(res.code === 0&&res.data){
							let loginInfo = {...res.data}
							localStorage.setItem('login',JSON.stringify(loginInfo));
							that.$utils.Burying({act:'loginSuccess',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
							Message.success('登录成功.即将进行跳转.')

							setTimeout(()=>{
								that.$bus.$emit('getLogin');
								
								that.yzmMsg = '获取验证码';
								that.yzmLoading = false;
								that.form = {
									sjh:'',
									yzm:''
								};
								
								let beforePath = localStorage['beforePath'];
								
								if(beforePath&&beforePath!=''){
									location.replace(beforePath);
									localStorage.removeItem('beforePath');
								}else{
									that.loginDialogShow = false;
									if(that.$route.name=="gameActive"||that.$route.name=="GameActive"){
										that.dialogClose()
										that.$bus.$emit('openOrder')
										return 
									}
									location.reload();									
								}
							},1500)
						}else{
							Message.error(res.msg)
						}
					})
					.catch(err=>{
						console.error(err);
					})
					// location.path = that.beforePath;
				}else{
					Message.warning('手机号/验证码不能为空.')
				}
			},
			openPay(){
			
			},
			getYZM(){
				let that = this;
				let reg =  /0?(1)[0-9]{9}/;
				if(!reg.test(that.form.sjh)){
					Message.warning('请输入正确的手机号.')
					return;
				}
				
				that.$utils.Burying({act:'getyanzhenma',operating_system:'web'});
				
				let url = 'api/v1/cloud_pc/sms_send_v2';
				// let data = {
				// 	phone:that.form.sjh,
				// 	type:1 //  // 1 客户端 2 后台
				// };
				const timestamp = parseInt(new Date().getTime() / 1000)
				const str = `kind=0&phone=${that.form.sjh}&platform=web&template_kind=0&timestamp=${timestamp}&type=1`
				const encryptor = new JSEncrypt()
				encryptor.setPublicKey(this.public_key)
				const sign = encryptor.encrypt(str)
				const params = {
					phone: that.form.sjh,
					template_kind: 0,
					type: 1,
					platform: 'web',
					timestamp: timestamp,
					kind: 0,
					sign: sign
				}
				document.querySelector('.yzmBtn').style.pointerEvents = 'none';
				that.$req.post(url,params)
				.then(res=>{
					
					if(res.code === 0&&res.data){
						Message.success('验证码发送成功,请注意查收.')
						that.$utils.Burying({act:'sendyanzhenma',if_success:'true'});
						that.setYZMInfo();
					}else{
						Message.error(res.msg)
						that.$utils.Burying({act:'sendyanzhenma',if_success:'false'});
						document.querySelector('.yzmBtn').style.pointerEvents = '';
					}
				})
				.catch(err=>{
					console.error(err);
				})
				
				
			},
			setYZMInfo(){
				let that = this;
				let number = 59;
				let timer = setInterval(()=>{
					that.yzmMsg = number + 's';
					that.yzmLoading = true;
					
					number--;
					if(number == -1){
						clearInterval(timer);
						that.yzmMsg = '获取验证码';
						that.yzmLoading = false;
						document.querySelector('.yzmBtn').style.pointerEvents = '';
					}
				},1000);
				
				
			},
			dialogClose(){
				let that = this;
				that.yzmMsg = '获取验证码';
				that.yzmLoading = false;
				that.form = {
					sjh:'',
					yzm:''
				};
				that.$bus.$emit('loginDialogShow',false)
			},
			loginOut(){
				let that = this;
				localStorage.removeItem('login');
				that.userInfo = {};
				that.$set(that.userInfo,{});
			},
		},
		watch:{
			'form.sjh':function(val){
				let that = this;
				that.form.sjh = val.replace(/\D/g, '');
			},
			'form.yzm':function(val){
				let that = this;
				that.form.yzm = val.replace(/\D/g, '');
			},
			'LoginShow':function(val){
				let that = this;
				if(val){
					that.$utils.Burying({act:'openLogin',operating_system:'web'});
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	
	.loginDialogClass{
		/deep/
		.el-input__inner{
				background:rgba(248,248,248,1);
				border-radius:39px;
				height:75px;
				// line-height: 75px;
		}
		/deep/
		.el-input--prefix .el-input__inner{
			padding-left: 55px;
		}
		/deep/
		.el-input__prefix{
			left: 15px;
		}
		/deep/
		.el-input__suffix{
			right: 20px;
		}
		/deep/
		.el-input{
			font-size: 20px;
		}
		/deep/
		.el-form-item__error{
			font-size: 15px;
			left: 50px;
		}
		.dialog_title{
			background: url('../assets/login/dialog_bg_xiao@2x.png') no-repeat  center;
			background-size: cover;
			height: 86.5px;
			border-radius:22px 22px 0px 0px;
			display: flex;
			position: absolute;
			width: 100%;
			z-index: 99;
			.left{
				flex: 1;
				.el-image{
					width: 110px;
					height: 100px;
					vertical-align: middle;
					position: relative;
					margin-top: -40px;
					margin-left: 5px;
				}
			}
			.mind{
				flex: 3;
				font-size:22px;
				font-family:MicrosoftYaHei;
				color:rgba(13,13,13,1);
				line-height:86.5px;
				display: inline-block;
				text-align: left;
				text-indent: 40px;
			}
			
			
		}
		.closeRight{
				width: 50px;
				height: 86.5px;
				// position: relative;
				.right_div{
					width: 80px;
					height: 120px;
					background: url('../assets/login/dialogClose@2x.png') no-repeat center;
					background-size: cover;
					border-radius: 0px 12px 12px 0px;
					display: inline-block;
					position: absolute;
					margin-left: 448px;
					margin-top: -2px;
					cursor: pointer;
					z-index: -1;
					right: -50px;
				}
				
		}
		.yzmBtn{
			background-color:rgba(249,221,74,1);
			color: #000;
			border-color: rgba(249,221,74,1);
			position: absolute;
			
			// margin-left: 258px;
			padding: 12px 15px;
			width: 135px;
			margin-top: 15px;
			font-size: 17px;
			right:56px;
		}
		// 兼容 IE11
		@media screen and(-ms-high-contrast:active),(-ms-high-contrast:none){
			.yzmBtn{
				margin-left: -170px;
			}
		}
		.btnHover:hover{
			background-color: #f9c14a !important;
		}
		.btnHover2:hover{
			background-color: #eeeeee !important;
			color: #606266;
		}
	}
	
</style>
